import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-primary-400 whitespace-nowrap">
              <i className="ri-movie-2-line text-xl w-6 h-6 flex items-center justify-center"></i>
              哈哈影院
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">电视剧</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动漫</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">综艺</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-100 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系方式</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-100 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors w-5 h-5 flex items-center justify-center" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors w-5 h-5 flex items-center justify-center" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors w-5 h-5 flex items-center justify-center" rel="nofollow" aria-label="B站">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}